import React from "react";
/**
 * Component to display error API message.
 * @returns Display message when we have connection problems with our API
 */
export default function ApiErrConnection() {
  return (
    <div>
      <h2>
        Sorry for the inconvenience. We are experiencing connection problems
        with our server.
      </h2>
    </div>
  );
}
